import { IAmenityType } from '../enums/amenity-types';
import { IAmenity, IAmenityList } from '../interfaces';

export class AmenityList implements IAmenityList {
  pullThrough?: boolean;
  backIn?: boolean;
  electricity?: boolean;
  water?: boolean;
  dump?: boolean;
  sewage?: boolean;
  cell?: boolean;
  wifi?: boolean;
  firesAllowed?: boolean;
  petsAllowed?: boolean;
  trash?: boolean;
  recycling?: boolean;
  table?: boolean;
  restroom?: boolean;
  shower?: boolean;
  laundry?: boolean;
  pool?: boolean;
  wheelchair?: boolean;
  evCharging?: boolean;
  fireRing?: boolean;
  outdoorGrill?: boolean;
  generatorOk?: boolean;
  outdoorLighting?: boolean;
  sunshade?: boolean;
  waterFill?: boolean;
  lockableStorage?: boolean;

  static fromAmenities(amenities: IAmenity[]): AmenityList {
    return amenities.reduce((amenityList, amenity) => {
      if (amenity.type && amenity.type !== 'custom' && amenity.type !== 'tents' && amenity.type !== 'vehicles') {
        amenityList[amenity.type] = true;
      }
      return amenityList;
    }, new AmenityList());
  }

  static toAmenityArray(amenityList: IAmenityList): IAmenity[] {
    const amenities: IAmenity[] = [];

    if (amenityList?.pullThrough) {
      amenities.push({ type: 'pullThrough' });
    }

    if (amenityList?.backIn) {
      amenities.push({ type: 'backIn' });
    }

    if (amenityList?.electricity) {
      amenities.push({ type: 'electricity' });
    }

    if (amenityList?.water) {
      amenities.push({ type: 'water' });
    }

    if (amenityList?.dump) {
      amenities.push({ type: 'dump' });
    }

    if (amenityList?.sewage) {
      amenities.push({ type: 'sewage' });
    }

    if (amenityList?.cell) {
      amenities.push({ type: 'cell' });
    }

    if (amenityList?.wifi) {
      amenities.push({ type: 'wifi' });
    }

    if (amenityList?.firesAllowed) {
      amenities.push({ type: 'firesAllowed' });
    }

    if (amenityList?.petsAllowed) {
      amenities.push({ type: 'petsAllowed' });
    }

    if (amenityList?.trash) {
      amenities.push({ type: 'trash' });
    }

    if (amenityList?.recycling) {
      amenities.push({ type: 'recycling' });
    }

    if (amenityList?.table) {
      amenities.push({ type: 'table' });
    }

    if (amenityList?.restroom) {
      amenities.push({ type: 'restroom' });
    }

    if (amenityList?.shower) {
      amenities.push({ type: 'shower' });
    }

    if (amenityList?.laundry) {
      amenities.push({ type: 'laundry' });
    }

    if (amenityList?.pool) {
      amenities.push({ type: 'pool' });
    }

    if (amenityList?.wheelchair) {
      amenities.push({ type: 'wheelchair' });
    }

    if (amenityList?.evCharging) {
      amenities.push({ type: 'evCharging' });
    }

    if (amenityList?.fireRing) {
      amenities.push({ type: 'fireRing' });
    }

    if (amenityList?.outdoorGrill) {
      amenities.push({ type: 'outdoorGrill' });
    }

    if (amenityList?.generatorOk) {
      amenities.push({ type: 'generatorOk' });
    }

    if (amenityList?.outdoorLighting) {
      amenities.push({ type: 'outdoorLighting' });
    }

    if (amenityList?.sunshade) {
      amenities.push({ type: 'sunshade' });
    }

    if (amenityList?.waterFill) {
      amenities.push({ type: 'waterFill' });
    }

    if (amenityList?.lockableStorage) {
      amenities.push({ type: 'lockableStorage' });
    }

    return amenities;
  }

  static toStringArray(amenityList: IAmenityList): IAmenityType['type'][] {
    const amenities: IAmenityType['type'][] = [];

    if (amenityList?.pullThrough) {
      amenities.push('pullThrough');
    }

    if (amenityList?.backIn) {
      amenities.push('backIn');
    }

    if (amenityList?.electricity) {
      amenities.push('electricity');
    }

    if (amenityList?.water) {
      amenities.push('water');
    }

    if (amenityList?.dump) {
      amenities.push('dump');
    }

    if (amenityList?.sewage) {
      amenities.push('sewage');
    }

    if (amenityList?.cell) {
      amenities.push('cell');
    }

    if (amenityList?.wifi) {
      amenities.push('wifi');
    }

    if (amenityList?.firesAllowed) {
      amenities.push('firesAllowed');
    }

    if (amenityList?.petsAllowed) {
      amenities.push('petsAllowed');
    }

    if (amenityList?.trash) {
      amenities.push('trash');
    }

    if (amenityList?.recycling) {
      amenities.push('recycling');
    }

    if (amenityList?.table) {
      amenities.push('table');
    }

    if (amenityList?.restroom) {
      amenities.push('restroom');
    }

    if (amenityList?.shower) {
      amenities.push('shower');
    }

    if (amenityList?.laundry) {
      amenities.push('laundry');
    }

    if (amenityList?.pool) {
      amenities.push('pool');
    }

    if (amenityList?.wheelchair) {
      amenities.push('wheelchair');
    }

    if (amenityList?.evCharging) {
      amenities.push('evCharging');
    }

    if (amenityList?.fireRing) {
      amenities.push('fireRing');
    }

    if (amenityList?.outdoorGrill) {
      amenities.push('outdoorGrill');
    }

    if (amenityList?.generatorOk) {
      amenities.push('generatorOk');
    }

    if (amenityList?.outdoorLighting) {
      amenities.push('outdoorLighting');
    }

    if (amenityList?.sunshade) {
      amenities.push('sunshade');
    }

    if (amenityList?.waterFill) {
      amenities.push('waterFill');
    }

    if (amenityList?.lockableStorage) {
      amenities.push('lockableStorage');
    }

    return amenities;
  }

  constructor(data?: IAmenityList) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IAmenityList): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
